/**
 * Helpers for matching "review tasks" (event occurrences) to the entity they
 * were scheduled for.
 *
 * A review task links back to its entity through an internal link that the
 * rich-text editor / planReview produce, e.g.
 *   <a data-internal-link-doctype="documents" data-internal-link-id="<uuid>" ...>
 *
 * Matching must key on that link, not on a bare substring of the uuid: template
 * based entities (tutorials, guides) use a short numeric id such as "3" as their
 * uuid, so a loose `description.includes(uuid)` matched virtually every task
 * whose description happened to contain that digit. (dabih-web#13486)
 */

/**
 * True when `description` contains an internal link pointing at the entity
 * identified by `entityType` (the link doctype) and `entityUuid` (the link id).
 *
 * Both attributes are required and matched with their surrounding quotes so a
 * short id like `3` does not match `data-internal-link-id="312616"`.
 */
export function descriptionLinksToEntity(
  description: string | undefined,
  entityType: string,
  entityUuid: string,
): boolean {
  if (!description || !entityType || !entityUuid) {
    return false;
  }
  const idMarker = `data-internal-link-id="${entityUuid}"`;
  const doctypeMarker = `data-internal-link-doctype="${entityType}"`;
  return description.includes(idMarker) && description.includes(doctypeMarker);
}
